/* iter55g24 — Mode-switch UX orchestrator.
 *
 * Listens for `activeMode` transitions and pops the appropriate
 * companion UI:
 *   • outline → 11-step Synopsis Builder dialog
 *   • revise  → RevisionModePanel (right-side drawer near editor)
 *   • world   → WorldBuilderDialog (accept-per-field deduce panel)
 *
 * Kept as a headless orchestrator so the mode picker in MenuBar
 * doesn't need to know about any dialog wiring. Uses refs to remember
 * the previous mode so we only trigger the UI on ENTRY into a mode,
 * not on every render.
 */
import { useEffect, useRef } from 'react';
import { usePW } from '@/lib/store';

export default function ModeSwitchHandler({ onOutline, onRevise, onWorld }) {
  const { activeMode } = usePW();
  const prev = useRef(activeMode);

  useEffect(() => {
    if (prev.current === activeMode) return;
    prev.current = activeMode;
    if (activeMode === 'outline') onOutline?.();
    else if (activeMode === 'revise') onRevise?.();
    else if (activeMode === 'world') onWorld?.();
  }, [activeMode, onOutline, onRevise, onWorld]);

  // Re-open companion panel when user clicks the already-active mode in ModeMenu.
  useEffect(() => {
    const onReopen = (e) => {
      const { mode } = e.detail || {};
      if (mode === 'revise')  onRevise?.();
      else if (mode === 'outline') onOutline?.();
      else if (mode === 'world')   onWorld?.();
    };
    window.addEventListener('loom:mode-reopen', onReopen);
    return () => window.removeEventListener('loom:mode-reopen', onReopen);
  }, [onRevise, onOutline, onWorld]);

  return null;
}
